import * as firebase from "firebase/app";
import "firebase/analytics";

import { subscribeLoggingFunction } from "../eventLogger";
import { getTenantNameFromHost } from "../tenant";

export function setup(config){
  firebase.initializeApp(config);
  
  const analytics = firebase.analytics();
  analytics.setUserProperties({
    tenant: getTenantNameFromHost()
  });

  subscribeLoggingFunction(analytics.logEvent);
}